import React, { useEffect } from "react";
import "./PalliativeCare.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";
import palliativeImg from "../../Asset/Images/PalliativeCare.jpeg";

const PalliativeCare = () => {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      duration: 1200,
      once: true,
    });
  }, []);

  const palliativePoints = [
    "palliative.point1",
    "palliative.point2",
    "palliative.point3",
    "palliative.point4",
    "palliative.point5",
    "palliative.point6",
    "palliative.point7",
    "palliative.point8"
  ];

  return (
    <div className="palliative_page">
      {/* HERO SECTION */}
      <section className="palliative_hero">
        <div className="palliative_card_container">
          <div className="palliative_content" data-aos="fade-right">
            <span className="service_tag">{t('palliative.service_tag')}</span>
            <h1>
              {t('palliative.title_start')} <span>{t('palliative.title_end')}</span>
            </h1>
            <p>{t('palliative.hero_desc')}</p>
          </div>

          <div className="palliative_image" data-aos="fade-left">
            <img src={palliativeImg} alt={t('palliative.title_start') + " " + t('palliative.title_end')} />
          </div>
        </div>
      </section>

      {/* DETAILS SECTION */}
      <section className="palliative_details">
        <h2 data-aos="fade-up">{t('palliative.details_title')}</h2>
        <div className="palliative_grid">
          {palliativePoints.map((key, index) => (
            <div className="palliative_card" key={index} data-aos="zoom-in">
              {t(key)}
            </div>
          ))}
        </div>
      </section>

      {/* CTA SECTION */}
      <section className="palliative_cta" data-aos="fade-up">
        <h2>{t('palliative.cta_title')}</h2>
        <p>{t('palliative.cta_desc')}</p>
        <NavLink to="/Contactus">
          <button className="assisted_cta_btn">
            {t('common.contact_us')}
          </button>
        </NavLink>
      </section>
    </div>
  );
};

export default PalliativeCare;